import React from 'react';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { ErrorFallback } from './pages/error/ErrorFallback';
import { Logger } from './plugins/logger/Logger';

// Route-level errors (loaders, suspended queries with throwOnError) land here
// instead of the top-level ErrorBoundary — keep the same fallback UI and
// exception telemetry the app had before the router migration.
const RouteErrorFallback = ({ error }: { error: Error }) => {
  React.useEffect(() => {
    Logger.trackException(error);
  }, [error]);
  return <ErrorFallback />;
};

export const router = createRouter({
  routeTree,
  defaultErrorComponent: RouteErrorFallback,
  // real values are injected via <RouterProvider context={...}> in EntryPoint,
  // where the Auth0 hooks needed to build the api client are available
  context: {
    queryClient: undefined!,
    apiClient: undefined!,
    assetLibraryApiClient: undefined!,
    auth: undefined!,
  },
  defaultPreload: 'intent',
  // React Query owns data staleness — always re-run loaders on preload and
  // let ensureQueryData decide whether to hit the network.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    /** Set on every navigation the asset library makes; see the media route's `beforeLoad`. */
    fromAssetLibrary?: boolean;
  }
}
